export default __webpack_public_path__ + "static/media/bathroom2-afterA-1920w.f8caa21b.avif";